// extracted by mini-css-extract-plugin
export default {"chromeframe":"image-loader_chromeframe__qq0FT","main":"image-loader_main__WBeWC","canvas":"image-loader_canvas__3aX5k","image":"image-loader_image__gx5AW"};